import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { Card } from "src/base-components/Card";
import { Select } from "src/base-components/Select";
import { EntitySchemaResource } from "src/entities/queries";
import { CustomTitle } from "src/entityActionNodes/LocateEntityCard";
import { ReadEntityNodeForm } from "src/entityActionNodes/ReadEntityNodeEditor";
import { EntityOptionValue } from "src/jobs/common/entitySource/EntityTypeSelector";

export const SelectEntityCard = ({
  entitySchemas,
  immutable,
  isLoading,
  title,
  onChange,
}: {
  entitySchemas: EntitySchemaResource[];
  immutable: boolean;
  isLoading: boolean;
  title: string;
  onChange?: (value: string) => void;
}) => {
  const formMethods = useFormContext<ReadEntityNodeForm>();

  const options = useMemo(() => {
    return (
      entitySchemas.map((entity) => ({
        key: entity._id,
        value: <EntityOptionValue entitySchema={entity} singular />,
      })) ?? []
    );
  }, [entitySchemas]);

  return (
    <Card>
      <Card.Header>
        <CustomTitle title={title} required />
      </Card.Header>
      <Card.Content>
        <div>
          <Controller
            control={formMethods.control}
            name="entity_schema"
            render={({ field }) => (
              <Select
                dataLoc="entity-schema-selector"
                disabled={immutable || isLoading}
                loading={isLoading}
                options={options}
                placeholder="Select Entity"
                value={field.value}
                onChange={(value) => {
                  field.onChange(value);
                  onChange?.(value);
                }}
              />
            )}
          />
        </div>
      </Card.Content>
    </Card>
  );
};
